import { render, staticRenderFns } from "./inventory-product-tile.vue?vue&type=template&id=2c0f9870&scoped=true&"
import script from "./inventory-product-tile.vue?vue&type=script&lang=js&"
export * from "./inventory-product-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0f9870",
  null
  
)

export default component.exports